import React from 'react';
import { ShieldCheck, Package, HardHat, Settings, FileText, BarChart } from 'lucide-react';
import { Card } from '@/components/ui';

const CATEGORIES = [
  {
    icon: ShieldCheck,
    title: 'Bảo mật & Phân quyền',
    description: 'Quản lý tài khoản, mật khẩu, và ma trận quyền hạn.',
    color: 'text-blue-600',
    bgColor: 'bg-blue-50',
  },
  {
    icon: Package,
    title: 'Kho & Vật tư',
    description: 'Quy trình xuất/nhập kho, lập đề xuất mua sắm.',
    color: 'text-emerald-600',
    bgColor: 'bg-emerald-50',
  },
  {
    icon: HardHat,
    title: 'Dự án & Thi công',
    description: 'Theo dõi tiến độ, nhật ký và nghiệm thu công trình.',
    color: 'text-orange-600',
    bgColor: 'bg-orange-50',
  },
  {
    icon: Settings,
    title: 'Cấu hình Công ty',
    description: 'Thiết lập phòng ban, nhân sự và quy trình duyệt.',
    color: 'text-purple-600',
    bgColor: 'bg-purple-50',
  },
  {
    icon: FileText,
    title: 'Quản lý Tài liệu',
    description: 'Tải lên, phê duyệt và lưu trữ bản vẽ, hợp đồng.',
    color: 'text-indigo-600',
    bgColor: 'bg-indigo-50',
  },
  {
    icon: BarChart,
    title: 'Báo cáo & Thống kê',
    description: 'Sử dụng Dashboard và trích xuất dữ liệu tài chính.',
    color: 'text-rose-600',
    bgColor: 'bg-rose-50',
  }
];

export function HelpCategoryGrid() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {CATEGORIES.map((cat, idx) => {
        const Icon = cat.icon;
        return (
          <Card key={idx} className="p-5 hover:shadow-md transition-shadow cursor-pointer border-slate-100 group">
            <div className={`w-10 h-10 rounded-lg ${cat.bgColor} ${cat.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
              <Icon size={20} />
            </div>
            <h3 className="sm:text-sm text-xs font-medium text-slate-900 mb-1.5">{cat.title}</h3>
            <p className="text-[11px] text-slate-500 leading-relaxed">
              {cat.description}
            </p>
          </Card>
        );
      })}
    </div>
  );
}
